import { Platform, ProjectID } from '@/types/platform'

export const getPlatformById = (id: ProjectID) => {
  return ProjectID[id] as Platform
}
